module.exports = __webpack_public_path__ + "static/img/nowPolice.9166ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nowPolice.png
// module id = ua4r
// module chunks = 208